import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(
    public toastController: ToastController,
    private translationService: TranslationService
  ) {}

  async errorToastWithClose(message: string) {
    const toast = await this.toastController.create({
      message: message,
      position: 'bottom',
      color: 'danger',
      duration: 5000,
      cssClass: 'toast',
      mode: 'ios',
      htmlAttributes: { tabindex: undefined },
      buttons: [
        {
          text: this.translationService.translate('Close'),
          role: 'cancel',
        },
      ],
    });
    await toast.present();
  }

  async warningToastWithClose(message: string) {
    const toast = await this.toastController.create({
      message: message,
      position: 'bottom',
      color: 'warning',
      duration: 2000,
      cssClass: 'toast',
      mode: 'ios',
      htmlAttributes: { tabindex: undefined },
      buttons: [
        {
          text: this.translationService.translate('Close'),
          role: 'cancel',
        },
      ],
    });
    await toast.present();
  }

  async successToastWithClose(message: string) {
    const toast = await this.toastController.create({
      message: message,
      position: 'bottom',
      color: 'success',
      duration: 2000,
      cssClass: 'toast',
      mode: 'ios',
      htmlAttributes: { tabindex: undefined },
      buttons: [
        {
          text: this.translationService.translate('Close'),
          role: 'cancel',
        },
      ],
    });
    await toast.present();
  }

  async successToast(message: string) {
    const toast = await this.toastController.create({
      message: message,
      position: 'bottom',
      color: 'success',
      duration: 2000,
      mode: 'ios',
      cssClass: 'toast',
      htmlAttributes: { tabindex: undefined },
    });
    await toast.present();
  }

  closeToaster() {
    this.toastController.dismiss();
  }

  async toast(message: string, button: string) {
    const toast = await this.toastController.create({
      message: message,
      position: 'bottom',
      duration: 5000,
      cssClass: 'toast',
      mode: 'ios',
      htmlAttributes: { tabindex: undefined },
      buttons: [
        {
          side: 'end',
          text: button,
          role: 'button',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
      ],
    });
    await toast.present();

    // const { role } = await toast.onDidDismiss();
    return await toast.onDidDismiss();
  }
}
